import React, { useEffect } from 'react';

const PublicationsList = () => {
  // Add hover effects and responsive styles on component mount
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* --- Hover Effects --- */
      .publication-card:hover {
        background-color: #262626 !important;
        border-color: #404040 !important;
      }
      .pdf-button:hover {
        background-color: #4b5563 !important;
      }
      .view-button:hover {
        background-color: #374151 !important;
      }
      .view-all-button:hover {
        background-color: #374151 !important;
      }

      /* --- Responsive Styles --- */
      @media (max-width: 768px) {
        .main-container {
          padding: 2.5em 1em !important;
        }
        .main-title {
          font-size: 2rem !important;
        }
        .publication-card {
          width: 95%;
          margin-left: auto;
          margin-right: auto;
          padding: 24px !important;
        }
        .actions {
          flex-direction: column;
          gap: 16px !important;
        }
        .pdf-button, .view-button {
          justify-content: center;
        }
      }
    `;
    document.head.appendChild(style);
    
    // Cleanup function to remove the style when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const publications = [
    { type: 'Journal Article', title: 'Democratizing AI Education: A Global Framework for Inclusive Learning', authors: 'Dr. Sarah Chen, Prof. Michael Rodriguez, Dr. Aisha Patel', journal: 'Nature AI Education', year: '2024', citations: '245 citations' },
    { type: 'Conference Paper', title: 'Ethical AI Development in Educational Contexts: Challenges and Solutions', authors: 'Prof. David Kim, Dr. Elena Rossi, Dr. James Wilson', journal: 'IEEE AI Ethics', year: '2024', citations: '189 citations' },
    { type: 'Research Paper', title: 'Cross-Cultural AI Learning Patterns: Insights from 50+ Countries', authors: 'Dr. Maria Santos, Prof. Ahmed Hassan, Dr. Lisa Thompson', journal: 'International Journal of AI Education', year: '2023', citations: '312 citations' },
    { type: 'Technical Report', title: 'Adaptive Learning Systems: Personalizing AI Education at Scale', authors: 'Dr. Robert Chang, Prof. Sophie Dubois, Dr. Raj Gupta', journal: 'ACM Education Technology', year: '2023', citations: '156 citations' }
  ];

  return (
    <div style={styles.container} className="main-container">
      <div style={styles.header}>
        <h1 style={styles.title} className="main-title">Our Recent Research Projects</h1>
        <p style={styles.subtitle}>
          Our latest research contributions to the global AI and education community.
        </p>
      </div>

      <div style={styles.publicationsList}>
        {publications.map((pub, index) => (
          <div key={index} style={styles.publicationCard} className="publication-card">
            <div style={styles.cardHeader}>
              <span style={styles.typeLabel}>{pub.type}</span>
            </div>
            
            <h3 style={styles.publicationTitle}>{pub.title}</h3>
            
          </div>
        ))}
      </div>

      <div style={styles.viewAllContainer}>
      </div>
    </div>
  );
};

// Base styles remain unchanged
const styles = {
  container: {
    margin: '0 auto',
    padding: '4em',
    backgroundColor: '#0a0a0a',
    color: '#ffffff',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  },
  header: {
    textAlign: 'center',
    marginBottom: '60px'
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '700',
    margin: '0 0 16px 0',
    color: '#ffffff'
  },
  subtitle: {
    fontSize: '1.125rem',
    color: '#9ca3af',
    margin: '0',
    lineHeight: '1.6'
  },
  publicationsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  publicationCard: {
    backgroundColor: '#1f1f1f',
    border: '1px solid #333333',
    borderRadius: '12px',
    padding: '32px',
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px'
  },
  typeLabel: {
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#d1d5db'
  },
  publicationTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#ffffff',
    margin: '0 0 16px 0',
    lineHeight: '1.4'
  },
  authors: {
    fontSize: '1rem',
    color: '#9ca3af',
    margin: '0 0 16px 0',
    lineHeight: '1.5'
  },
  metadata: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    marginBottom: '24px'
  },
  journal: {
    fontSize: '0.875rem',
    color: '#d1d5db',
    fontWeight: '500'
  },
  year: {
    fontSize: '0.875rem',
    color: '#9ca3af'
  },
  citations: {
    fontSize: '0.875rem',
    color: '#9ca3af'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end'
  },
  pdfButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    backgroundColor: '#374151',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  viewButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    backgroundColor: 'transparent',
    color: '#ffffff',
    border: '1px solid #374151',
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  downloadIcon: {
    fontSize: '0.875rem'
  },
  externalIcon: {
    fontSize: '0.875rem'
  },
  viewAllContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '48px'
  },
  viewAllButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 24px',
    backgroundColor: 'transparent',
    color: '#ffffff',
    border: '1px solid #374151',
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  listIcon: {
    fontSize: '1rem'
  }
};

export default PublicationsList;